<template>
  <div class="nav-header-bar">
    <van-nav-bar fixed :title="navBarTitle" left-arrow @click-left="goBack">
      <div slot="left" v-if="isLeft">
        <img class="left-img" src="@/assets/images/nav_home.png" alt="">
      </div>
      <div slot="title" class="nav-title">
        <img v-if="isShowLogo" class="logo-img" :src="globalData.nationalFlagImg" alt="">
        <span class="title-info">{{ navBarTitle }}</span>
      </div>
      <div slot="right" v-if="commandList.length > 0" class="command-content" @click="toggleExpand">
        <span v-if="otherParams.pageType !== 'sea'"><van-icon size="26px" name="ellipsis" /></span>
        <div class="expand-content" :class="{ 'expanded': isExpanded }">
          <div v-for="(subItem, subIndex) in commandList" :key="subIndex" class="expand-item" @click.stop="handleCommand(subItem)">
            <template v-if="!subItem.auth || checkPer(subItem.auth)">
              <van-icon class="icon-img" size="26px" color="#666" :name="subItem.icon" />
              <span>{{ subItem.label }}</span>
            </template>
          </div>
        </div>
      </div>
      <div slot="right" v-else>
        <slot></slot>
      </div>
    </van-nav-bar>
    <div class="nav-bar"></div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'NavHeaderBar',
  props: {
    navBarTitle: {
      type: String,
      default: ''
    },
    commandList: {
      type: Array,
      default: () => []
    },
    otherParams: {
      type: Object,
      default: () => {}
    },
    isShowLogo: {
      type: Boolean,
      default: false
    },
    isLeft: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isExpanded: false
    }
  },
  computed: {
    ...mapState({
      globalData: 'globalData'
    })
  },
  methods: {
    goBack () {
      if (localStorage.getItem('centerPoint')) {
        localStorage.removeItem('centerPoint')
      }
      this.$router.go(-1)
      this.$emit('backReturn')
    },
    toggleExpand () {
      this.isExpanded = !this.isExpanded
    },
    handleCommand (params) {
      this.$emit('command', params)
      this.isExpanded = false
    }
  }
}
</script>

<style lang="less" scoped>
.nav-header-bar {
  .nav-bar {
    margin-top: 46px;
  }
}
/deep/.van-nav-bar {
  background-color: #fff;
  .van-nav-bar__content {
    display: flex;
    align-items: center;
  }
  .van-nav-bar__left {
    width: 54px;
  }
  .van-nav-bar__right {
    min-width: 54px;
    padding: 0;
    padding-left: 6px;
  }
  .van-nav-bar__title {
    max-width: 65%;
    flex: 1;
  }
  .van-icon {
    color: #000;
  }
}
.nav-title {
  // width: 260px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  padding: 0 5px;
  .title-info {
    font-size: 18px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #000;
  }
  .logo-img {
    width: 34px;
    // height: 20px;
    margin-right: 5px;
  }
}
.left-img {
  width: 26px;
  height: 26px;
}
.van-nav-bar--fixed {
  z-index: 999;
}
.command-content {
  position: relative;
  padding: 0 8px;
  .expand-content {
    position: absolute;
    top: 100%;
    right: 0;
    background: #fff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    border-radius: 4px;
    opacity: 0;
    overflow: hidden;
    transform: scaleY(0);
    transform-origin: top;
    transition: transform 0.3s ease, opacity 0.3s ease;
    z-index: 100;
    min-width: 160px;
    .expand-item {
      display: flex;
      align-items: center;
      padding: 10px;
      color: #323233;
      font-size: 12px;
      transition: background-color 0.2s ease;
      border: 1px solid #f1f1f1;
      .icon-img {
        margin-right: 3px;
      }
    }
    .expand-item:active {
      background-color: #f7f8fa;
    }
  }
  .expanded {
    opacity: 1;
    transform: scaleY(1);
  }
}
</style>
